/**
 * Action Dependencies
 */
import { fetchProjects } from '../../../services/ProjectService'

/**
 * Retrieve the projects from the API
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const getProjects = ({ commit }, params = {}) => {
    commit('GET_PROJECTS')
    setTimeout(() => {
        return fetchProjects(params)
            .then(res => {
                commit('GET_PROJECTS_SUCCESS', res.data)
                return res.data
            })
            .catch(err => {
                commit('GET_PROJECTS_FAILED')
                return err
            })
    }, 500)
}

/**
 * Reset the project list
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetProjects = ({ commit }) => {
    return new Promise((resolve, reject) => {
        commit('RESET_PROJECT_LIST_DATA')
        resolve('reset')
    })
}

/**
 * Set the project data
 *
 * @param  {Object} options.commit
 * @param  {Object} data
 * @return {Promise}
 */
const setProjectData = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        commit('SET_PROJECT_LIST', data)
        setTimeout(() => {
            commit('RESET_PENDING_PROJECTS')
            resolve(data)
        }, 3000)
    })
}

/**
 * Reset the user context to its original state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * Replace the project data
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {object} payload
 * @return {Void}
 */
const replaceProjectData = ({ commit, state }, payload) => {
    let target = state.data[payload.index]
    if (target && target.id === payload.project.id) {
        commit('REPLACE_PROJECT_DATA', payload)
    }
}

/**
 * Change the layout rendering engine
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const toggleLayout = ({ commit }, payload) => {
    commit('UPDATE_LAYOUT', payload)
}

export default {
    resetState,
    getProjects,
    toggleLayout,
    resetProjects,
    setProjectData,
    replaceProjectData
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/actions.js